/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 13:22:02
 * @LastEditTime: 2023-02-14 16:49:16
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Customer/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Link from '@/src/components/Link/Link';
import CustomerSelectionNoPagination from '@/src/constrains/CustomerSelectionNoPagination';
import { request_saveCustomerDetail } from '@/src/request/customer/customerDetail';
import { getFilterOptions } from '@/src/request/customer/list';
import { getCustomerDetail } from '@/src/request/order/createOrder';
import { nameTrans } from '@/src/tools/helper';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { Timeline } from 'antd';
import _, { get } from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import { EnumFieldType } from 'src/components/FieldModal/config';
import { SectionWrapper } from 'src/components/Layouts';
import ModalHoc from 'src/constrains/ModalHOC';
import CustomerInfoModal from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { saveInternalRemark } from 'src/request/order';
import { LogisticMethod } from 'src/types/common/logisticMethod';
import InternalRemark from '../InternalRemark';
import BuyerInfo from './BuyerInfo';
import FapiaoInfo from './FapiaoInfo';
import RecipientInfo from './RecipientInfo';
import SenderInfo from './SenderInfo';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//此组件在create new Order和 Order Detail中都用到了
import css from './css.module.less';
import { useSelector } from 'react-redux';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
//此组件在create new Order和 Order Detail , subscriptionBuy中都用到了
const Customer = (props) => {
  const areaCodes = useSelector(getAreaCodes());
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    customerDetail,
    crossBoarder,
    dbUuid,
    reLoadOrderPage,
    hideBuyer,
    hideBillingAddress,
    customer, //只有createOrder才有
    setCustomer, //只有createOrder才有
    salesChannelUuid,
    getVouchers, //只有createOrder才有
    hideCustomerRemark,
    hideOrderInternalRemark,
    buildData, //拿到所有的CreatOrder数据
    setCustomerDetail,
    languageCode,
    setBuyerInfo,
    buyerInfo,
    billingAddressDetail,
    setBillingAddressDetail,
    recipientInfo,
    setRecipientInfo,
    orderUuid,
    getRecipientReq,
    saveRecipientReq,
    isSubscription,
    invoice,
    setInvoice,
    showInvoice,
    disabled,
    parcelSender,
    setParcelSender,
    products,
    handleApply,
    handlGetFees,
    pickupInfo,
    disableRecipientEdit,
  } = props;
  const {
    registered,
    userRemarks,
    internalRemark,
    customerInteractions,
    logisticsMethod,
  } = customerDetail || {};

  const findCustomerFields = (
    data, //customerInfoFields的数据结构并且带有value的数据
    customerInfoFields, //customerInfoFields的数据结构value中是null
    sameKey,
    key,
    valueKey,
  ) => {
    // 格式化数据，将buyer info数据提取出来，方便展示
    let firstName = '';
    let lastName = '';
    let fullName = '';
    let buyerEmail = '';
    let buyerPhoneNo = '';
    const buyerInfoData = data.map((item) => {
      //因为data数据可能和customerInfoFields数据不一致（存在修改了配置的情况）所以这里需要过滤一下，避免出现error
      const buyerInfoIndex = customerInfoFields.filter(
        (o) => o.field[sameKey] == item.field[sameKey],
      );
      const field = get(buyerInfoIndex, `0.field`);
      const k = get(field, `${key}`);
      if (k == EnumFieldType.FirstName) {
        firstName = item[valueKey][0];
      }

      if (k == EnumFieldType.LastName) {
        lastName = item[valueKey][0];
      }

      if (k == EnumFieldType.FullName) {
        fullName = item[valueKey][0];
      }
      if (k == EnumFieldType.Email) {
        buyerEmail = item[valueKey][0];
      }
      if (
        k == EnumFieldType.MobileNumber ||
        k == EnumFieldType.AreaCodeMobileNumber
      ) {
        // console.log('item', item, 'valueKey', valueKey);
        const arr = item[valueKey];
        const areaCodeUuid = get(arr, 0);
        const mobileNumber = get(arr, 1);

        const areaCodeInText = get(
          areaCodes.find((i) => i.uuid === areaCodeUuid),
          'areaCode',
        );
        buyerPhoneNo = `${areaCodeInText || ''} ${mobileNumber || ''}`;
      }

      return { field, [valueKey]: item[valueKey] };
    });
    return {
      firstName,
      fullName,
      buyerEmail,
      buyerPhoneNo,
      lastName,
      buyerInfoData,
    };
  };

  const { run: _getCustomerDetail } = useRequest(getCustomerDetail, {
    manual: true,
    onSuccess: (result) => {
      const fullNameAutoPopulate = result.fullNameAutoPopulate || {
        firstNameFirst: false,
        separator: '',
      };
      const customerInfoFields = result.customerInfoFields;
      // setBuyerInfo({ customerInfoFields });
      const {
        buyerInfoData,
        firstName,
        lastName,
        fullName,
        buyerEmail,
        buyerPhoneNo,
      } = findCustomerFields(
        customerInfoFields,
        customerInfoFields.map((item) => ({
          field: item.field,
          value: [],
        })),
        'uuid',
        'fieldType',
        'value',
      );
      //console.log('buyerPhoneNo', buyerPhoneNo);
      handleChangeCustomer({
        buyerName: nameTrans(
          fullNameAutoPopulate,
          firstName,
          lastName,
          fullName,
        ),
        buyerEmail,
        buyerPhoneNo,
      });

      setBuyerInfo({
        ...buyerInfo,
        customerInfoFields: buyerInfoData,
      });
    },
  });

  const { run: runSaveInternalRemark } = useRequest(
    (data) => saveInternalRemark({ ...data, orderUuid }),
    {
      manual: true,
      onSuccess: () => {
        handleCancel();
        reLoadOrderPage();
      },
    },
  );

  //添加Customer弹窗
  const { run: _getFilterOptions } = useRequest(
    () => getFilterOptions(dbUuid),
    {
      manual: true,
      onSuccess: (res) => {
        const { customerInfoFields } = res;
        const customerInfoFieldsCover = customerInfoFields.map((item) => ({
          field: item,
          value: [],
        }));
        setWidth(600);
        setShowModal(true);
        setModalTitle(
          getI18n('allOrders.createneworder.component_customer_popup_title'),
        );
        setModalContent(
          <CustomerInfoModal
            onCancel={handleCancel}
            fields={customerInfoFieldsCover}
            onConfirm={(e) => {
              const obj = {
                customerInfoFields: e,
                customerDBUuid: dbUuid,
                uuid: null,
              };
              const cb = (obj) => {
                const { uuid, customerInfoFields } = obj;
                const fullNameValues = customerInfoFields.filter(
                  (o) => get(o, 'field.fieldType') === EnumFieldType.FullName,
                );
                const fullName = fullNameValues[0].value.join(' ');
                setCustomer({
                  uuid,
                  fullName,
                });
                handleApply({ customer: { uuid, fullName } });
                handleCancel();
              };
              return request_saveCustomerDetail(obj).then((res) => {
                return { response: res, cb };
              });
            }}
          />,
        );
      },
    },
  );
  const handleChangeCustomer = (data) => {
    setCustomerDetail({
      ...customerDetail,
      ...data,
    });
  };

  const activitiesList = (customerInteractions || []).map((activity) => ({
    ...activity,
    date: activity.dateTime
      ? moment(activity.dateTime).format('DD MMM YYYY')
      : '',
    time: activity.dateTime ? moment(activity.dateTime).format('hh:mm') : '',
  }));

  const customerInteractionsList = _.groupBy(activitiesList, 'date');

  const handleCancel = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const handelEditInternalRemark = () => {
    setShowModal(true);
    setWidth(600);
    setModalTitle(
      getI18n(
        'allOrders.createneworder.component_customer_handelEditInternalRemark_title',
      ),
    );
    setModalContent(
      <InternalRemark
        initValue={internalRemark}
        onCancel={handleCancel}
        onOk={runSaveInternalRemark}
      />,
    );
  };

  const handleSearchCustomerConfirm = (customer) => {
    const _customer = customer[0];
    _getCustomerDetail(_customer.uuid);
    setCustomer(_customer);
    handleApply({ customer: _customer });
    getVouchers({ salesChannelUuid, customer: _customer });
    handleCancel();
  };
  const handleSearchCustomer = () => {
    setWidth(900);
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allOrders.createneworder.component_customer_handleSearchCustomer_title',
      ),
    );
    setModalContent(
      //此组件为公共customer选择组件，谨慎修改
      <CustomerSelectionNoPagination
        selected={[]}
        onCancel={handleCancel}
        onConfirm={handleSearchCustomerConfirm}
        dbUuid={dbUuid}
        rowSelectionType='radio'
      />,
    );
  };

  const removeCustomer = () => {
    setCustomer();
    handleApply({ customer: null });
    setBuyerInfo(null);
    setBillingAddressDetail(null);
    setRecipientInfo(null);
    setCustomerDetail(null);
    setParcelSender(null);
    // setBuyerInfo();
    // setBillingAddressDetail();
    // setRecipientInfo();
    // setCustomerDetail();
    // setParcelSender();
    // handleApply();
  };

  return (
    <SectionWrapper
      title={getI18n(
        'allOrders.createneworder.component_customer_return_title',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      {customer && (
        <div className={css.customItem}>
          <h3>
            {getI18n(
              'allOrders.orderDetail.component_customer_handleSearchCustomer_title',
            )}
          </h3>
          <div className={css.customItemName}>
            <span> {customer.fullName || customer.uuid} </span>
            {!crossBoarder && !disabled ? (
              <Icon onClick={removeCustomer} type='icona-close3' />
            ) : (
              ''
            )}{' '}
          </div>
          <Link
            className={css.viewCustomer}
            to={`/customerDatabase/customerDetail/${dbUuid}/${customer.uuid}`}>
            {getI18n('allOrders.createneworder.component_customer_return_link')}
          </Link>
        </div>
      )}
      {(customer || customerDetail) && (
        <BuyerInfo
          customer={customer}
          disabled={crossBoarder || disabled}
          registered={registered}
          customerDetail={customerDetail}
          reLoadOrderPage={reLoadOrderPage}
          salesChannelUuid={salesChannelUuid}
          orderUuid={orderUuid}
          setBillingAddressDetail={setBillingAddressDetail}
          billingAddressDetail={billingAddressDetail}
          setBuyerInfo={setBuyerInfo}
          buyerInfo={buyerInfo}
          findCustomerFields={findCustomerFields}
          languageCode={languageCode}
          changeCustomer={handleChangeCustomer}
          hideBillingAddress={hideBillingAddress}
          hideBuyer={hideBuyer}
        />
      )}
      {(customer || customerDetail) && (
        <RecipientInfo
          customer={customer}
          disabled={crossBoarder || disabled || disableRecipientEdit}
          salesChannelUuid={salesChannelUuid}
          reLoadOrderPage={reLoadOrderPage}
          orderUuid={orderUuid}
          buyerInfo={buyerInfo}
          recipientInfo={recipientInfo}
          languageCode={languageCode}
          buildData={buildData}
          isSubscription={isSubscription}
          setRecipientInfo={setRecipientInfo}
          setBillingAddressDetail={setBillingAddressDetail}
          customerDetail={customerDetail}
          getRecipientReq={getRecipientReq}
          saveRecipientReq={saveRecipientReq}
          changeCustomer={handleChangeCustomer}
          findCustomerFields={findCustomerFields}
          products={products}
          handlGetFees={handlGetFees}
          pickupInfo={pickupInfo}
        />
      )}
      {(customer || customerDetail) &&
        (logisticsMethod === LogisticMethod.Delivery ||
          logisticsMethod === LogisticMethod.ParcelLocker) && (
          <SenderInfo
            disabled={crossBoarder || disabled}
            customer={customer}
            orderUuid={orderUuid}
            parcelSender={parcelSender}
            setParcelSender={setParcelSender}
            reLoadOrderPage={reLoadOrderPage}
          />
        )}
      {(customer || customerDetail) && showInvoice && (
        <FapiaoInfo
          disabled={crossBoarder || disabled}
          customer={customer}
          orderUuid={orderUuid}
          invoice={invoice}
          reLoadOrderPage={reLoadOrderPage}
          changeCustomer={handleChangeCustomer}
          setInvoice={setInvoice}
        />
      )}
      {!hideCustomerRemark && (customer || customerDetail) && (
        <div className={css.customItem}>
          <h3>
            {' '}
            {getI18n(
              'allOrders.createneworder.component_customer_return_remarkitem',
            )}
          </h3>
          <span>{userRemarks}</span>
        </div>
      )}
      {!hideOrderInternalRemark && (customer || customerDetail) && (
        <div className={css.customItem}>
          <h3>
            {getI18n(
              'allOrders.createneworder.component_customer_return_Internal_remarkitem',
            )}
            {disabled ? (
              <Icon className={css.disable} type='iconedit' />
            ) : (
              <Icon type='iconedit' onClick={handelEditInternalRemark} />
            )}
          </h3>
          <span>{internalRemark}</span>
        </div>
      )}
      {(!hideCustomerRemark || !hideOrderInternalRemark) &&
        (customer || customerDetail) && <div className={css.splitLine}></div>}
      {(customerInteractions || []).length ? (
        <div className={css.customItem}>
          <h3>{getI18n('allOrders.orderDetail.customerInteractions')}</h3>
          <Timeline className={css.activityTimeline}>
            {Object.entries(customerInteractionsList).map((item, itemIndex) => (
              <Fragment key={itemIndex}>
                <Timeline.Item className={css.noTimelineItem} dot={<div></div>}>
                  <span className={css.timelineTitle}>{item[0]}</span>
                </Timeline.Item>
                {item[1].map((list, listIndex) => (
                  <Timeline.Item key={listIndex}>
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: list.comment,
                        }}></div>
                    </div>
                    <span className={css.timelineItem}>{list.time}</span>
                  </Timeline.Item>
                ))}
              </Fragment>
            ))}
          </Timeline>
        </div>
      ) : null}
      {!customerDetail && !customer && (
        <div>
          <Button
            type='primary'
            disabled={!dbUuid || disabled}
            className={css.searchCustomer}
            onClick={handleSearchCustomer}>
            {getI18n(
              'allOrders.createneworder.component_customer_return_searchBtn',
            )}
          </Button>
          <p
            className={
              !dbUuid || disabled
                ? css.disabledCreateCustomer
                : css.createCustomer
            }
            onClick={() => {
              _getFilterOptions();
            }}>
            <Icon type='iconplus' />
            {getI18n(
              'allOrders.createneworder.component_customer_return_createIcon',
            )}
          </p>
        </div>
      )}
    </SectionWrapper>
  );
};
export default ModalHoc(Customer);
